export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 10-f1961a836499f72832399858a5162932.png";